import { TWebsiteBuilderContainer } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderContainer";
import { IWebsiteBuilderGrid } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderGrid";
import { IWebsiteBuilderTabset } from "pages/secure/facility/websiteBuilder/editor/nodes/container/websiteBuilderTabset";
import { TWebsiteBuilderElement } from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { TWebsiteBuilderSection } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderSection";
import { IWebsiteBuilderGridCell } from "pages/secure/facility/websiteBuilder/editor/nodes/gridCell/websiteBuilderGridCell";
import { TWebsiteBuilderElementContainerParentNode, TWebsiteBuilderElementParentNode } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderNode";
import { IWebsiteBuilderSectionEntityLayoutData, IWebsiteBuilderSectionEntityStretch, TWebsiteBuilderSectionEntityLayout } from "pages/secure/facility/websiteBuilder/editor/nodes/websiteBuilderSectionEntity";
import { IWebsiteBuilderTab } from "pages/secure/facility/websiteBuilder/editor/nodes/tab/websiteBuilderTab";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";

type TWebsiteBuilderSectionEntityContextBase = {
  layout: TWebsiteBuilderSectionEntityLayout;
  activeLayoutData: IWebsiteBuilderSectionEntityLayoutData;
  zIndex: number;
}

type TWebsiteBuilderSectionEntityInSectionContextBase = {
  activeScreenLayoutData: IWebsiteBuilderSectionEntityLayoutData;
  stretch: IWebsiteBuilderSectionEntityStretch;
}

type TWebsiteBuilderElementInSectionContext = TWebsiteBuilderSectionEntityContextBase & TWebsiteBuilderSectionEntityInSectionContextBase & {
  type: "element-in-section";
  node: TWebsiteBuilderElement;
  parentNode: Extract<TWebsiteBuilderElementParentNode, TWebsiteBuilderSection>;
  rootNode: IWebsiteBuilderRoot;
}

type TWebsiteBuilderContainerInSectionContext = TWebsiteBuilderSectionEntityContextBase & TWebsiteBuilderSectionEntityInSectionContextBase & {
  type: "container-in-section";
  node: TWebsiteBuilderContainer;
  parentNode: TWebsiteBuilderSection;
  rootNode: IWebsiteBuilderRoot;
}

type TWebsiteBuilderSectionEntityInSectionContext = TWebsiteBuilderElementInSectionContext | TWebsiteBuilderContainerInSectionContext;

type TWebsiteBuilderElementInContainerContext = TWebsiteBuilderSectionEntityContextBase & {
  type: "element-in-container";
  node: TWebsiteBuilderElement;
  parentNode: Extract<TWebsiteBuilderElementParentNode, TWebsiteBuilderElementContainerParentNode>;
  sectionNode: TWebsiteBuilderSection;
}

type TWebsiteBuilderElementInGridCellContext = TWebsiteBuilderSectionEntityContextBase & {
  type: "element-in-grid-cell";
  node: TWebsiteBuilderElement;
  parentNode: Extract<TWebsiteBuilderElementParentNode, IWebsiteBuilderGridCell>;
  gridNode: IWebsiteBuilderGrid;
  sectionNode: TWebsiteBuilderSection;
}

type TWebsiteBuilderElementInTabContext = TWebsiteBuilderSectionEntityContextBase & {
  type: "element-in-tab";
  node: TWebsiteBuilderElement;
  parentNode: Extract<TWebsiteBuilderElementParentNode, IWebsiteBuilderTab>;
  tabsetNode: IWebsiteBuilderTabset;
  sectionNode: TWebsiteBuilderSection;
}

export type TWebsiteBuilderElementViewContext = 
  | TWebsiteBuilderElementInSectionContext
  | TWebsiteBuilderElementInContainerContext
  | TWebsiteBuilderElementInGridCellContext
  | TWebsiteBuilderElementInTabContext;

export type TWebsiteBuilderContainerViewContext = TWebsiteBuilderContainerInSectionContext;

export type TWebsiteBuilderSectionEntityViewContext =
  | TWebsiteBuilderElementViewContext
  | TWebsiteBuilderContainerViewContext;

export function isWebsiteBuilderSectionEntityInSectionContext(context: TWebsiteBuilderSectionEntityViewContext): context is TWebsiteBuilderSectionEntityInSectionContext {
  return context.type === "element-in-section" || context.type === "container-in-section";
}

export function isWebsiteBuilderElementViewContext(context: TWebsiteBuilderSectionEntityViewContext): context is TWebsiteBuilderElementViewContext {
  return (
    context.type === "element-in-section" ||
    context.type === "element-in-container" ||
    context.type === "element-in-grid-cell" ||
    context.type === "element-in-tab"
  );
}

export function isWebsiteBuilderContainerViewContext(context: TWebsiteBuilderSectionEntityViewContext): context is TWebsiteBuilderContainerViewContext {
  return context.type === "container-in-section";
}